import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function TomosSection() {
  const tomos = [{
    icon: '🔧',
    title: 'Tomo 1',
    subtitle: 'Mecánica de Precisión en Casa',
    desc: 'Hacé vos mismo el 90% de lo que pagás en el taller',
    color: 'from-[#22c55e]/10 to-transparent',
    border: 'border-t-[#22c55e]'
  }, {
    icon: '📐',
    title: 'Tomo 2',
    subtitle: 'Biomecánica: Tu Bici Como un Guante',
    desc: 'Eliminá los dolores y pedalear con la eficiencia de un profesional',
    color: 'from-[#4ade80]/10 to-transparent',
    border: 'border-t-[#4ade80]'
  }, {
    icon: '⚡',
    title: 'Tomo 3',
    subtitle: 'El Motor Humano: Potencia Real',
    desc: 'El sistema de entrenamiento para subir tu FTP sin entrenador ni potenciómetro caro',
    color: 'from-[#16a34a]/10 to-transparent',
    border: 'border-t-[#16a34a]'
  }, {
    icon: '🎯',
    title: 'Tomo 4',
    subtitle: 'Estrategia de Ruta y MTB',
    desc: 'Técnica y táctica para rendir más con el mismo esfuerzo',
    color: 'from-[#15803d]/10 to-transparent',
    border: 'border-t-[#15803d]'
  }, {
    icon: '📱',
    title: 'Tomo 5',
    subtitle: 'Electrónica y Software Pro',
    desc: 'Dominá tus dispositivos y convertí datos en decisiones reales',
    color: 'from-[#22c55e]/10 to-transparent',
    border: 'border-t-[#22c55e]'
  }, {
    icon: '🔩',
    title: 'Tomo 6',
    subtitle: 'Mantenimiento Avanzado y Suspensiones',
    desc: 'El nivel del mecánico profesional desde tu garage',
    color: 'from-[#4ade80]/10 to-transparent',
    border: 'border-t-[#4ade80]'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-6xl mx-auto" data-id="element-378">
      <FadeIn data-id="element-379">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-380">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-381">
            📚
          </span>{' '}
          LOS 6 TOMOS
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-382">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-383">
            <motion.div whileHover={{
          y: -5,
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} className={`bg-white border border-[#e2e8f0] ${tomo.border} border-t-4 hover:border-[#22c55e] transition-all rounded-2xl p-4 md:p-8 h-full flex flex-col relative overflow-hidden shadow-sm hover:shadow-xl`} data-id="element-384">
              <div className={`absolute inset-0 bg-gradient-to-b ${tomo.color} opacity-50 pointer-events-none`} data-id="element-385"></div>

              <div className="absolute top-3 right-3 md:top-4 md:right-4 text-[10px] md:text-xs font-black tracking-widest text-[#16a34a] bg-[#f8fafc] px-2 py-0.5 md:px-3 md:py-1 rounded-full border border-[#e2e8f0]" data-id="element-386">
                TOMO 0{index + 1}
              </div>

              <div className="text-4xl md:text-6xl mb-3 md:mb-6 relative z-10 drop-shadow-sm" data-id="element-387">
                {tomo.icon}
              </div>

              <h3 className="text-lg md:text-xl font-black text-[#0f172a] mb-1.5 md:mb-2 relative z-10" data-id="element-388">
                {tomo.subtitle}
              </h3>

              <p className="text-sm md:text-base text-[#475569] font-medium leading-relaxed flex-grow relative z-10" data-id="element-389">
                {tomo.desc}
              </p>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}